"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useModalSize = void 0;
var _uiActions = require("../../store/ui/uiActions");
var _uiSelectors = require("../../store/ui/uiSelectors");
var _widgetSelectors = require("../../store/widget/widgetSelectors");
var _useAppDispatch = require("../useAppDispatch");
var _useAppSelector = require("../useAppSelector");
const useModalSize = () => {
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  const currentModalSize = (0, _useAppSelector.useAppSelector)(_uiSelectors.selectCurrentModalSize);
  const pageSizes = (0, _useAppSelector.useAppSelector)(_widgetSelectors.selectSectionSizes);
  const getPageSize = page => {
    return pageSizes[page];
  };
  const setModalSizeBySize = size => {
    dispatch((0, _uiActions.setModalSize)(size));
  };
  const setModalSizeByName = page => {
    dispatch((0, _uiActions.setModalSize)(getPageSize(page)));
  };
  return {
    currentModalSize,
    setModalSizeBySize,
    setModalSizeByName
  };
};
exports.useModalSize = useModalSize;